"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleHorizontalPos = exports.handleVerticalPos = void 0;
var handleVerticalPos = function (calenderRef, inputRef) {
    var _a, _b;
    if (!calenderRef.current || !inputRef.current)
        return;
    var height = ((_a = calenderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect()).height;
    var inputBottom = ((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect()).bottom;
    var innerHeight = window.innerHeight;
    // innerHeight -= 30;
    if (inputBottom + height > innerHeight) {
        calenderRef.current.style.top = "".concat(-height, "px");
    }
    else {
        calenderRef.current.style.top = "";
    }
};
exports.handleVerticalPos = handleVerticalPos;
var handleHorizontalPos = function (calenderRef, id) {
    var _a;
    if (!calenderRef || !calenderRef.current)
        return;
    var innerWidth = window.innerWidth;
    var _b = (_a = calenderRef.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect(), left = _b.left, right = _b.right, width = _b.width;
    if (id === 0) {
        if (left > width / 2) {
            calenderRef.current.style.right = '0';
        }
        else {
            calenderRef.current.style.right = '';
        }
    }
    if (id === 1) {
        if (innerWidth > width / 2 + right) {
            calenderRef.current.style.left = '0';
        }
        else {
            calenderRef.current.style.left = '';
        }
    }
};
exports.handleHorizontalPos = handleHorizontalPos;
